var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAtomicosmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#atomicosmall_svg__clip0_1345_57495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.098 9.51a4.967 4.967 0 01-3.468-1.391 4.662 4.662 0 010-6.728c1.912-1.854 5.024-1.854 6.937 0a4.663 4.663 0 010 6.728 4.969 4.969 0 01-3.469 1.391zm0-6.457c-.45 0-.9.166-1.241.498a1.668 1.668 0 000 2.408 1.797 1.797 0 002.483 0 1.67 1.67 0 000-2.408 1.778 1.778 0 00-1.242-.498z",
    fill: "#99DBCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81 25.037c-3.16 0-5.724-2.486-5.724-5.553 0-3.066 2.563-5.552 5.725-5.552 3.161 0 5.724 2.486 5.724 5.552 0 3.067-2.563 5.553-5.724 5.553zm5.517-13.138l-.001-.001c-1.506-1.15-3.47-1.93-5.515-1.93C4.392 9.969 0 14.229 0 19.485S4.392 29 9.81 29c2.046 0 4.08-.823 5.517-1.93v1.694h4.01v-18.56h-4.01V11.9z",
    fill: "#002631"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "atomicosmall_svg__clip0_1345_57495"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v29H0z"
  })))));
}

export default SvgAtomicosmall;